import { createStore } from "redux";
import { User, UserType } from "./Profile";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export type AppState = {
  user: User;
  redirect_uri: string;
  token: string;
};

type Action = {
  type: string;
  payload: any;
};

const initialState: AppState = {
  user: {
    user_type: UserType.Unknown,
    industry_index: -1,
    field_index: -1,
    name: "",
    email: "",
    phone: "",
    linkedin: "",
    experiences: [],
    projects: [],
    educations: [],
    skills: [],
    score: {
      total_skills: 1,
      total_numbers: 1,
      total_wording: 1,
      total_verbage: 1,
      total: 2,
      bullets: [],
      num_questions: 0,
    },
    resume_uuid: "",
    preferred_template: "Basic One Column",
  },
  redirect_uri: "/",
  token: "",
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case "UPDATE_STATE":
      return {
        ...state,
        user: action.payload,
      };
    case "UPDATE_URI":
      return {
        ...state,
        redirect_uri: action.payload,
      };
    case "UPDATE_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    default:
      return state;
  }
};

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer);

const persistor = persistStore(store);
